import { createFileRoute, redirect } from '@tanstack/react-router'
import { getPreferredLang } from '@/hooks/useLang'

export const Route = createFileRoute('/tools/')({
  beforeLoad: async () => {
    throw redirect({
      to: '/$lang/tools',
      params: { lang: await getPreferredLang() },
      replace: true,
    })
  },
})
